import { render, staticRenderFns } from "./OrdersSelector.vue?vue&type=template&id=f68af6ee&scoped=true"
import script from "./OrdersSelector.vue?vue&type=script&lang=js"
export * from "./OrdersSelector.vue?vue&type=script&lang=js"
import style0 from "./OrdersSelector.vue?vue&type=style&index=0&id=f68af6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68af6ee",
  null
  
)

export default component.exports